import React, {Component} from 'react';
import {Row, Col, Button} from 'antd';
import {Link} from 'react-router';
import BreadcrumbToolbar from './layouts/BreadcrumbToolbar'
import StationButtonInfo from './StationButtonInfo'
import StationButtonStatisticDeviceData from './StationButtonStatisticDeviceData'

class StationToolbar extends Component {
  render() {
    const {station, devices, rooms, showAction, onReboot, onSyncReq, location} = this.props
    const viewLayout = location.pathname.indexOf('layout') > -1
      ? true
      : false
    const linkTo = viewLayout
      ? `/station/${station.ID}`
      : `/station/${station.ID}/layout`
    return (<Row type="flex" align="middle" className="toolbar" justify="end">
      <Col xs={{
          span: 12
        }} sm={{
          span: 12
        }} md={{
          span: 12
        }} lg={{
          span: 12
        }} xl={{
          span: 12
        }}>
        <BreadcrumbToolbar items={this.props.breadcrumbs}/>
      </Col>
      <Col xs={{
          span: 12
        }} sm={{
          span: 12
        }} md={{
          span: 12
        }} lg={{
          span: 12
        }} xl={{
          span: 12
        }}>
        <div className="right">
          <StationButtonInfo station={station} showAction={showAction} onReboot={onReboot} onSyncReq={onSyncReq}/>
          <StationButtonStatisticDeviceData station={station}/>
        </div>
      </Col>
    </Row>)
  }

}

export default StationToolbar;
/*
<Link to={linkTo}>
  {
    viewLayout
      ? <Button type="primary" ghost="ghost" icon="layout"></Button>
      : <Button type="primary" ghost="ghost" icon="appstore-o"></Button>
  }
</Link>
*/



// WEBPACK FOOTER //
// ./src/components/StationToolbar.js